export const PERMISSIONS = {
  roleManagement: 'Role Management',
  userManagement: 'User Management',
  customer: 'Customer',
  insurerManagement: 'Insurer Management',
  planManagement: 'Plan Management',
  dealerMaster: 'Dealer Master',
  transaction: 'Transaction',
  banner: 'Banner',
  popup: 'Pop-up',
  page: 'Pages',
  products: 'Products',
  benefit: 'Benefit',
  faq: 'FAQ'
}
